export const TEST_NAME_MAP = {
    1: "NVCBM_TO_NVCBS",
    2: "NVCBM_TO_PDB",
    3: "NVCBM_TO_HMI",
    4: "AC_SUPPLY_CHECK",
    5: "BATTERY_VOLTAGE",
    // Add all mappings
  };